import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, onClose, incidentId, onViewReport, onCreateNew }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-lg border border-border max-w-md w-full p-6 shadow-modal">
        {/* Success Icon */}
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
            <Icon name="CheckCircle" size={32} className="text-success" />
          </div>
        </div>

        {/* Success Message */}
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-foreground mb-2">
            Incident Report Submitted Successfully
          </h2>
          <p className="text-muted-foreground mb-4">
            Your incident report has been submitted and logged in the system with immutable audit trail.
          </p>
          
          {/* Incident ID */}
          <div className="bg-muted/30 rounded-lg p-4 mb-4">
            <div className="flex items-center justify-center space-x-2">
              <Icon name="Hash" size={16} className="text-primary" />
              <span className="text-sm text-muted-foreground">Incident ID:</span>
              <span className="font-mono font-medium text-primary">{incidentId}</span>
            </div>
          </div>

          {/* Blockchain Confirmation */}
          <div className="bg-success/5 border border-success/20 rounded-lg p-3 mb-4">
            <div className="flex items-center justify-center space-x-2 mb-2">
              <Icon name="Shield" size={16} className="text-success" />
              <span className="text-sm font-medium text-success">Blockchain Secured</span>
            </div>
            <p className="text-xs text-muted-foreground">
              Hash-chain consent receipt generated for regulatory compliance
            </p>
          </div>
        </div>

        {/* Next Steps */}
        <div className="bg-muted/30 rounded-lg p-4 mb-6">
          <h3 className="text-sm font-medium text-foreground mb-2 flex items-center">
            <Icon name="Clock" size={16} className="mr-2 text-primary" />
            What happens next?
          </h3>
          <ul className="text-xs text-muted-foreground space-y-1">
            <li>• Safety manager will be notified immediately</li>
            <li>• Investigation will begin within 24 hours</li>
            <li>• You'll receive updates via email and dashboard</li>
            <li>• Follow-up actions will be assigned as needed</li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            onClick={onViewReport}
            iconName="FileText"
            iconPosition="left"
            fullWidth
          >
            View Report
          </Button>
          
          <Button
            variant="outline"
            onClick={onCreateNew}
            iconName="Plus"
            iconPosition="left"
            fullWidth
          >
            Report Another
          </Button>
          
          <Button
            onClick={onClose}
            fullWidth
          >
            Close
          </Button>
        </div>

        {/* Additional Actions */}
        <div className="mt-4 pt-4 border-t border-border">
          <div className="flex justify-center space-x-4 text-sm">
            <button className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-clinical">
              <Icon name="Download" size={14} />
              <span>Download PDF</span>
            </button>
            
            <button className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-clinical">
              <Icon name="Share" size={14} />
              <span>Share Report</span>
            </button>
            
            <button className="flex items-center space-x-1 text-primary hover:text-primary/80 transition-clinical">
              <Icon name="Bell" size={14} />
              <span>Set Reminders</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;